import { LANGUAGE_COOKIE, LANGUAGE_HEADER_KEY } from "@crehana/constants";
import { LANGUAGES } from "@crehana/ts-types";
import parseCookies from "./parseCookies.js";
function getG11nDataFromHeaders(headers) {
    let language = null;
    let country = null;
    const countryFromHeader = headers['creh-country'];
    const cookies = headers.cookie ? parseCookies(headers.cookie) : {};
    if (countryFromHeader) country = '*' !== countryFromHeader ? countryFromHeader.toLowerCase() : '';
    else if (headers.cookie) {
        country = cookies.__creh_country_code;
        country = country && '*' !== country ? country.toLowerCase() : '';
    }
    language = cookies[LANGUAGE_COOKIE] || headers[LANGUAGE_HEADER_KEY] || ('br' === country ? 'pt' : 'es');
    return {
        countryCode: country || '',
        languageCode: language || LANGUAGES.ES
    };
}
const utils_getG11nDataFromHeaders = getG11nDataFromHeaders;
export default utils_getG11nDataFromHeaders;
export { getG11nDataFromHeaders };
